(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/poker/playscan-message.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/poker/playscan-message.js');

'use strict';

svs.player_login.views.poker.PlayscanMessage = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.poker_mandatory_msg(data);
  }
});

 })(window);